<div
    fxLayout="column"
    fxLayoutAlign="space-between stretch"
    class="sidebar-container"
    [class.expanded]="sidebarOpened()">
    <div
        class="p-a-sm cipo--border-bottom--solid cipo--border-radius-xs"
        fxFlex="none"
        fxLayout
        fxLayoutAlign="end center">
        @if (sidebarOpened()) {
            <cipo-text #searchField fxFlex="80" class="m-r-xs" [control]="searchControl" [fieldData]="fieldData()" />
        }
        @let tooltip = "actions." + (sidebarOpened() ? "collapse" : "expand") | translate;
        <button
            #toggleBtn
            mat-icon-button
            fxFlex="none"
            (click)="toggleSidebar()"
            color="accent"
            [matTooltip]="tooltip"
            [attr.aria-label]="tooltip">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
                {{ sidebarOpened() ? "right_panel_open" : "right_panel_close" }}
            </mat-icon>
        </button>
    </div>
    @if (selectedEntityInstanceId() === 0) {
        <div fxFlex="none" class="item disabled" data-testid="document-sidebar-new-document" aria-current="true">
            <div class="indicator"></div>
            @let newLabel = "dm.details.newDocument" | translate: { module: moduleName() };
            <p [title]="newLabel" class="cipo-text--bold-md cipo--text--ellipsed">{{ newLabel }}</p>
        </div>
    }
    <cdk-virtual-scroll-viewport
        cipoKeyboardList
        [itemCount]="items().length"
        [ariaLabel]="'a11y.documentSidebar.list' | translate"
        fxFlex="grow"
        class="items-container"
        [itemSize]="sidebarOpened() ? 60 : 40"
        (scrolledIndexChange)="onScroll()">
        <div
            *cdkVirtualFor="let item of dmStore.sidebar.items(); trackBy: virtualTrackBy; let i = index"
            role="button"
            tabindex="-1"
            [attr.data-list-index]="i"
            [attr.aria-current]="item.entity_instance_id === selectedEntityInstanceId() ? 'true' : null"
            [attr.aria-disabled]="isRowDisabled(item) ? 'true' : null"
            (click)="documentClick(item)"
            (keydown.enter)="documentClick(item)"
            (keydown.space)="$event.preventDefault(); documentClick(item)"
            class="item"
            [class.disabled]="isRowDisabled(item)">
            @if (item.entity_instance_id === selectedEntityInstanceId()) {
                <div class="indicator"></div>
            }
            <!-- Disable sidebar navigation if document is in edit mode -->
            <div fxLayout fxLayoutAlign="space-between">
                <p
                    [fxFlex]="sidebarOpened() ? 40 : 100"
                    [title]="item.full_doc_num"
                    class="cipo-text--bold-md cipo--text--ellipsed">
                    {{ item.full_doc_num }}
                </p>
                @if (sidebarOpened()) {
                    <cipo-state
                        fxFlex="60"
                        [bgColor]="item.state_name.bgColor"
                        [textColor]="item.state_name.color"
                        [name]="item.state_name.label" />
                }
            </div>
            @if (sidebarOpened() && descriptionField()) {
                @switch (descriptionField().typeId) {
                    @case (FieldTypeEnum.YesNo) {
                        @let value = "general.boolValue." + item.description_field_value | translateInsensitive;
                        <p [title]="value" class="cipo--text--ellipsed">{{ value }}</p>
                    }
                    @case (FieldTypeEnum.Date) {
                        @let value =
                            item.description_field_value | itvDateTimeWithRestrictions: descriptionField().restrictions;
                        <p [title]="value" class="cipo--text--ellipsed">{{ value }}</p>
                    }
                    @case (FieldTypeEnum.Number) {
                        @let value =
                            item.description_field_value
                                | itvNumberWithFormattings
                                    : descriptionField().formattings
                                    : descriptionField().restrictions
                                    : userStore.currency();
                        <p [title]="value" class="cipo--text--ellipsed">{{ value }}</p>
                    }
                    @default {
                        <p [title]="item.description_field_value" class="cipo--text--ellipsed">
                            {{ item.description_field_value }}
                        </p>
                    }
                }
            }
        </div>
        @if (isLoading()) {
            <div
                class="p-a-lg cipo--border-bottom--lite"
                role="status"
                [attr.aria-busy]="true"
                [attr.aria-label]="'a11y.documentSidebar.loading' | translate">
                @if (sidebarOpened()) {
                    <ngx-skeleton-loader
                        [theme]="{ width: '40%', height: '16px', margin: '4px' }"
                        [count]="2"></ngx-skeleton-loader>
                }
                <ngx-skeleton-loader [theme]="{ width: '80%', height: '12px', margin: '0' }"></ngx-skeleton-loader>
            </div>
        }
    </cdk-virtual-scroll-viewport>
    @if (sidebarOpened()) {
        <div fxFlex="none" class="cipo-card-container p-y-xs">
            @let loaded = items().length | itvNumber;
            @let total = dmStore.sidebar().records | itvNumber;
            <p fxFlex>
                {{ "general.table.itemsLoaded" | translate: { loaded, total } }}
            </p>
        </div>
    }
</div>
